import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { ownershipService } from "../services/ownership.service";
import { QUERY_KEYS } from "../config/queryKeys";

interface UseOwnershipRequestsParams {
  page: number;
  limit: number;
  status?: "pending" | "approved" | "rejected";
}

export const useOwnershipRequests = ({ page, limit, status }: UseOwnershipRequestsParams) => {
  return useQuery({
    queryKey: [QUERY_KEYS.OWNERSHIP_REQUESTS, page, status],
    queryFn: () => ownershipService.getOwnershipRequests({ page, limit, status }),
    refetchInterval: 1000 * 5,
  });
};

export const useApproveOwnershipRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => ownershipService.approveOwnershipRequest(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.OWNERSHIP_REQUESTS] });
    },
  });
};

export const useRejectOwnershipRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => ownershipService.rejectOwnershipRequest(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.OWNERSHIP_REQUESTS] });
    },
  });
}; 